import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  MenuItem,
  Select,
  FormControl,
  InputLabel
} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { DatePicker } from "@material-ui/pickers";

import { useAuth } from "../../context/GlobalContext";
import formatDate from "../../components/Control/formatDate";
import useConfirm from "../../components/Control/useConfirm";
import UpdateIcon from "@material-ui/icons/Update";
import ApprovalSelect from "./ApprovalSelect";
import ApprovalSupervisor from "./ApprovalSupervisor";
import CustomSelect from "../../common/CustomSelect";
import { Wrapper } from "../../components/Control/Flexbox";

const useStyles = makeStyles({
  table: {
    width: "100%",
    marginTop: "1.5rem",
    backgroundColor: "white",
  },
});
const statusObj = {
  pending: 1,
  accepted: 2,
  rejected: 3,
};
const ScrapNoteList = () => {
  const classes = useStyles();
  const { state } = useAuth();
  const [dailyproductionData, setDailyProductionData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [render, setRender] = useState(false);
  const [scrapLocations, setScrapLocations] = useState([]);
  const [filter, setFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const [DialogDelete, confirmDelete] = useConfirm(
    "SAVE",
    "Are you sure you want to Delete this report?"
  );

  useEffect(() => {
    axios
      .get(`/api/getYearlyScapNote/${selectedDate}`)
      .then((res) => {
        setDailyProductionData(res.data);
        setFilteredData(res.data);
      });
  }, [selectedDate, render]);

  
  useEffect(() => {
    let isMounted = true;
    axios
      .get(`/api/getAllScrapLocations`)
      .then((res) => {
        if (isMounted) {
          setScrapLocations(res.data?.result || []); // Update state only if component is mounted
        }
      })
      .catch((err) => console.log(err));
      return () => {
        isMounted = false; // Set flag to false when component unmounts
      };
  }, []);



  useEffect(() => {
    if (filter === "") {
      setFilteredData(dailyproductionData);
    } else {
      const filtered = dailyproductionData.filter(
        (item) => item.scrap_location_name === filter
      );
      setFilteredData(filtered);
    }
  }, [filter, dailyproductionData]);
  

  const handleDelete = async (id) => {
    // const isConfirm = window.confirm(
    //   "Are you sure you want to delete this document" 
    // );
    const isConfirm = await confirmDelete();
    if (isConfirm) {
      axios
        .delete(`/api/deleteScrapNoteById/${id}`)
        .then((res) => {
          alert("success deleted");
          setRender((prev) => !prev);
        })
        .catch((err) => console.error(err));
    }
  };

  const handleChangeStatus = (e, index) => {
    const values = [...dailyproductionData];
    values[index].is_admin_request = null;
    values[index].is_admin_request_no = e.target.value;
    setDailyProductionData(values);
  };

  const updateStatus = async (id, index) => {
    let isConfirm = window.confirm("Are you sure you want to update status");
    if (!isConfirm) return;

    axios
      .patch(`/api/updateStatusScapNoteById/${id}`, {
        is_admin_request_no: dailyproductionData[index].is_admin_request_no,
        report_approved_by: state.user?.name,
      })
      .then((res) => {
        if (res.data.status === "success") {
          alert("Status Change successfully");
        }
        setRender((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <section>
      <div style={{}}>
        <div
          className="divflex"
          style={{
            fontSize: "24px",
          }}
        >
          SCRAP NOTE REPORT
          <div>
            {(state.user.userType === 3 || state.user.userType === 2) && (
              <Link
                to={`/scrapNoteAddEdit`}
                style={{ color: "white", textDecoration: "none" }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{
                    backgroundColor: "#054a29",
                  }}
                  startIcon={<AddCircleIcon />}
                >
                  New Report
                </Button>
              </Link>
            )}
          </div>
        </div>

        <div className="subheading-container">
          <p className="subheading-primary">
            ACTIVE <span className="subheading-secondary">REPORTS</span>
          </p>
        </div>
      </div>


      <Wrapper className="jutify-content:space-between flex-direction-row">
        <div style={{ display: "flex", margin: "1rem",  flex: "0.8"  }}>
          <DatePicker
            views={["month", "year"]}
            label="Month & Year"
            className="date-field"
            inputVariant="filled"
            value={selectedDate || null}
            onChange={setSelectedDate}
          />
        </div>
        <FormControl
              variant="filled"
              className="select-field"
              style={{
                marginRight: "1.5rem",
                marginTop: "0.8rem",
                flex: "0.2",
                type: "flex",
                justifyItems: "right"
              }}
            >
              <InputLabel>Filter by location</InputLabel>
              <Select
                name="filter"
                onChange={(e) => setFilter(e.target.value)}
                value={filter}
              >
                <MenuItem value="">All Locations</MenuItem>
                {scrapLocations.map((location) => (
                  <MenuItem key={location._id} value={location.location_name}>
                    {location.location_name}
                  </MenuItem>
                ))}
                {/*<MenuItem value="">None</MenuItem>

                <MenuItem value="OPEN">OPEN</MenuItem>
                <MenuItem value="WORK IN PROGRESS">WORK IN PROGRESS</MenuItem> 
                <MenuItem value="CLOSED">CLOSED</MenuItem>
              */}
              </Select>
            </FormControl>
        
      </Wrapper>
      

      <Table className={classes.table} size="small">
        <TableHead>
          <TableRow style={{ padding: "6px" }}>
            {["#", "Scrap Note Date", "Location","Scrap Location", "Status", "Action"].map(
              (item, index) => (
                <TableCell style={{ fontWeight: "bold" }} align="center">
                  {item}
                </TableCell>
              )
            )}
            {state.user?.userType === 2 && (
              <TableCell style={{ fontWeight: "bold" }} align="center">
                Update
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        {filteredData && (
          <TableBody>
            {filteredData.map((item, index) => (
              <React.Fragment key={item._id}>
                <TableRow>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">
                    {formatDate(item.scrapnote_date)}
                  </TableCell>
                  <TableCell align="center">{item.location}</TableCell>
                  <TableCell align="center">{item.scrap_location_name}</TableCell>
                  {/* approval */}
                  {state.user?.userType === 2 && (
                    <TableCell align="center">
                      <ApprovalSelect
                        {...{
                          handleChangeStatus,
                          item,
                          index,
                          statusObj,
                        }}
                      />
                    </TableCell>
                  )}

                  {state.user?.userType === 3 && (
                    <TableCell align="center">
                      <ApprovalSupervisor
                        {...{
                          item,
                        }}
                      />
                    </TableCell>
                  )}

                  {/* ---x--- */}

                  {/*  */}

                  <TableCell align="center">
                    <Tooltip title="View Scrap Note" arrow>
                      <Link to={`/scrapNoteAddEdit/${item._id}?isView=true`}>
                        <IconButton size="small">
                          <VisibilityIcon
                            style={{
                              fontSize: "1.4rem",
                              color: "#003566",
                            }}
                          />
                        </IconButton>
                      </Link>
                    </Tooltip>
                    {state.user.userType !== 3 && (
                      <>
                        <Tooltip title="Edit Scrap Note" arrow>
                          <Link
                            to={`/scrapNoteAddEdit/${item._id}?isView=false`}
                          >
                            <IconButton
                              size="small"
                              style={{ marginLeft: "0.5rem" }}
                            >
                              <EditIcon
                                style={{
                                  fontSize: "1.4rem",
                                  color: "#003566",
                                }}
                              />
                            </IconButton>
                          </Link>
                        </Tooltip>
                        <Tooltip title="Delete Scrap Note" arrow>
                          <IconButton
                            size="small"
                            onClick={() => handleDelete(item._id)}
                            style={{ marginLeft: "0.5rem" }}
                          >
                            <DeleteIcon
                              style={{
                                fontSize: "1.4rem",
                                color: "#c80202",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}

                    {/* for supervisor */}
                    {state.user.userType == 3 && !item.isSubmitted && (
                      <>
                        <Tooltip title="Edit Scrap Note" arrow>
                          <Link
                            to={`/scrapNoteAddEdit/${item._id}?isView=false`}
                          >
                            <IconButton
                              size="small"
                              style={{ marginLeft: "0.5rem" }}
                            >
                              <EditIcon
                                style={{
                                  fontSize: "1.4rem",
                                  color: "#003566",
                                }}
                              />
                            </IconButton>
                          </Link>
                        </Tooltip>
                        <Tooltip title="Delete Scrap Note" arrow>
                          <IconButton
                            size="small"
                            onClick={() => handleDelete(item._id)}
                            style={{ marginLeft: "0.5rem" }}
                          >
                            <DeleteIcon
                              style={{
                                fontSize: "1.4rem",
                                color: "#c80202",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                  </TableCell>

                  {state.user?.userType === 2 && (
                    <TableCell align="center">
                      <Button
                        variant="outlined"
                        color="white"
                        style={{
                          color: "#fafafa",
                          backgroundColor: "#161A1D",
                        }}
                        onClick={(e) => {
                          updateStatus(item._id, index);
                        }}
                        startIcon={
                          <UpdateIcon style={{ fontSize: "1.4rem" }} />
                        }
                      >
                        Update
                      </Button>
                    </TableCell>
                  )}
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        )}
      </Table>
      <DialogDelete isSubmitContent={true} />
    </section>
  );
};

export default ScrapNoteList;
